import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {useNavigateWithReload} from "base/hooks";
import {SidebarPanelLayout} from "base/layout";
import {AlertError, SectionCard} from "base/component/presentational";
import {
    FeaturedDocumentDownload,
    ImagePreview,
} from "document/component/presentational";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import LaunchIcon from "@mui/icons-material/Launch";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import {ChangesAlertBox} from "changes/presentational";

const EntitySummaryPanel = ({
    service,
    id,
    title,
    getSectionTitle,
    getSectionData,
    onClickDetailButton = null,
    showClickDetailButton = entity => true,
    children = null,
}) => {
    const navigate = useNavigateWithReload();

    const [error, setError] = useState("");

    const location = useLocation();
    const basePath = location.pathname.split("/info/")[0];

    const [entity, setEntity] = useState(null);
    const [loading, setLoading] = useState(null);

    useEffect(() => {
        setLoading(true);
        setEntity(null);
        setError(null);
        service
            .get(id)
            .then(entity => {
                setEntity(entity);
            })
            .catch(error => {
                setError(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);

    const handleClose = () => {
        navigate(`${basePath}`);
    };

    const handleClickDetail = entity => {
        if (onClickDetailButton) {
            onClickDetailButton(entity);
        }
    };

    return (
        <SidebarPanelLayout sidebarTitle={title} closeSidebarClick={handleClose}>
            {loading ? (
                <Grid item container justifyContent="center" my={6}>
                    <CircularProgress size={40} />
                </Grid>
            ) : (
                entity && (
                    <>
                        <SectionCard title={getSectionTitle(entity)}>
                            <ChangesAlertBox
                                pending_status={entity.pending_status}
                                sx={{mb: 2}}
                            />
                            {entity.featured_image && (
                                <Box sx={{mb: 3}}>
                                    <ImagePreview
                                        path={entity.featured_image}
                                        alt={entity.nome}
                                    />
                                </Box>
                            )}
                            <AlertError error={error} />
                            {getSectionData(entity)}
                            {entity.featured_document && (
                                <Grid container justifyContent="center" sx={{mt: 2}}>
                                    <FeaturedDocumentDownload
                                        featuredDocument={entity.featured_document}
                                    />
                                </Grid>
                            )}
                            {onClickDetailButton && showClickDetailButton(entity) && (
                                <Grid container justifyContent="center" sx={{mt: 2}}>
                                    <Button
                                        variant="contained"
                                        sx={{ml: 3}}
                                        onClick={() => handleClickDetail(entity)}
                                        startIcon={<LaunchIcon />}
                                    >
                                        Ver detalle
                                    </Button>
                                </Grid>
                            )}
                        </SectionCard>
                        {children}
                    </>
                )
            )}
        </SidebarPanelLayout>
    );
};

export default EntitySummaryPanel;
